import React from "react"

const License = () => (
  <div className="w-full text-center bg-igem-footer md:pb-12 lg:pb-0">
    <span className="font-raleway-light font-light text-xs">
      Ⓒ 2022 - Content on this site is licensed under a{" "}
    </span>
    <a
      href="https://creativecommons.org/licenses/by/4.0/"
      target="_blank"
      className="font-raleway-medium font-semibold text-xs hover:underline"
    >
      Creative Commons Attribution 4.0 International license
    </a>
    <span className="font-raleway-light font-light text-xs">
      . The repository used to create this website is available at
    </span>
    <a
      className="text-igem-blue text-xs font-raleway-light font-light hover:underline"
      href="https://gitlab.igem.org/2022/vilnius-lithuania"
      target="_blank"
    >
      {" "}
      gitlab.igem.org/2022/vilnius-lithuania.
    </a>
  </div>
)

export default License
